import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAzureLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 121,
	viewBox: "0 0 120 121",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M120 23.361V96.321L90 120.887L43.5 103.958V120.741L17.1771 86.3439L93.9 92.3439V26.6439L120 23.361ZM94.4229 27.0296L51.3771 0.886719V18.0381L11.8457 29.6524L0 44.8581V79.3924L16.9543 86.8753V42.621L94.4229 27.0296Z",
		fill: "url(#paint0_linear_645_1109)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_645_1109",
		x1: 60,
		y1: 120.51,
		x2: 60,
		y2: 1.10957,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#0078D4" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .16,
				stopColor: "#1380DA"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .53,
				stopColor: "#3C91E5"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .82,
				stopColor: "#559CEC"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#5EA0EF"
			})
		]
	}) })]
});
export default SvgAzureLight;
